import { z } from "zod";

/// Wire-shape mirror of the shore `GET /me/entitlements` contract. Mirrors
/// `pulsewise-shore/src/modules/entitlements/me/entitlements-me.service.ts`
/// (`MeEntitlements`) exactly, drift will break the parser at runtime so it
/// surfaces in dev/QA, not silently in production.
///
/// `features` is keyed by every catalog feature key (shore's `FEATURES` in
/// `catalog/feature-catalog.ts`), not just the 8 product keys the UI gates
/// on, see `entitlements.constants.ts` for that narrower list. Nullable
/// `credits.grant` / `credits.remaining` / `seats.cap` all mean "unlimited".

const entitlementFeatureSchema = z
  .object({
    enabled: z.boolean(),
    limitValue: z.number().nullable(),
  })
  .strict();
export type EntitlementFeature = z.infer<typeof entitlementFeatureSchema>;

const entitlementsCreditsSchema = z
  .object({
    used: z.number(),
    grant: z.number().nullable(),
    remaining: z.number().nullable(),
  })
  .strict();

const entitlementsSeatsSchema = z
  .object({
    used: z.number(),
    cap: z.number().nullable(),
  })
  .strict();

export const entitlementsResponseSchema = z
  .object({
    plan: z.string(),
    features: z.record(z.string(), entitlementFeatureSchema),
    credits: entitlementsCreditsSchema,
    seats: entitlementsSeatsSchema,
  })
  .strict();
export type Entitlements = z.infer<typeof entitlementsResponseSchema>;
